webpackJsonp([21223537494785],{

/***/ 489:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulMember":{"name":"Steinar Andreassen","designation":"Co-Founder","thumbnail":{"file":{"url":"//images.ctfassets.net/1o5ly3na7qu2/6DCDGDAXf2QoCquYEkGWeU/1a64ea76e0bddee88ff5419ffb7cd668/Steinar.jpg"}},"content":{"content":"![blogMSA002A](//images.contentful.com/1o5ly3na7qu2/2D9fZow1zmG06uEAYmEmY4/159c920928728713b1902eb546d9ccac/blogMSA002A.JPG)\n\n__Steinar Andreassen__\n- MSA Co-Founder\n- Amateur astronomer, astrophotographer"}}},"pathContext":{"id":"c9vPxNqplKM2SeksmgSggC"}}

/***/ })

});


// WEBPACK FOOTER //
// path---member-steinar-andreassen-2baae325b4b03915deb5.js